angular.module('ui.omqlTester', [])

    .config(function ($stateProvider) {
        $stateProvider.state('omql', {
            url: '/omql',
            templateUrl: 'app/ui/omqlTester/omqlTester.html',
            controller: 'OmqlTesterController',
            data: {pageTitle: 'OrderManager: OMQL test page'}
        });
    })

    .controller('OmqlTesterController', function ($scope, orderItemsRepository, $localStorage) {

        var localStorageKey = "om.omqlTester";
        var oldValues = $localStorage.getItem(localStorageKey);
        if (oldValues) {
            $scope.where = oldValues.where;
            $scope.orderBy = oldValues.orderBy;
        }

        $scope.$watchGroup(['where', 'orderBy'], watcher);

        function watcher(newValues, oldValues) {
            if (!_.isEqual(newValues, oldValues)) {
                $localStorage.setItem(localStorageKey, {
                    where: $scope.where,
                    orderBy: $scope.orderBy
                });
            }
        }

        $scope.submit = function () {
            $scope.results = "loading...";

            orderItemsRepository.search({
                where: $scope.where,
                orderBy: $scope.orderBy,
                "pageNumber": 0,
                "rowsPerPage": 50
            }).then(
                function (resp) {
                    if (resp) {
                        resp.items = _.map(resp.items, function (i) {
                            return i.getServerModel();
                        });
                        $scope.results = JSON.stringify(resp, null, 4);
                    } else {
                        $scope.results = "NULL";
                    }
                }, function (resp) {
                    $scope.results = resp.message || "Unknown error";
                });

        };

    })

;